import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../components/AboutChoose/AboutChoose.css";
import { FaHandHoldingDroplet } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AboutChoose = () => {
    const sliderRef = useRef(null);
    const navigate = useNavigate();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: false,

        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    const data = [
        {
            title: "One stop solution",
            description: "Stelmart offers a comprehensive, unified platform for all your steel and polymer needs—simplifying business transactions in one place.",
            icon: require("../../assets/images/i3.png"),
        },
        {
            title: "Trust and Transparency",
            description: "Verified participants and secure transactions ensure credibility and peace of mind in every deal.",
            icon: require("../../assets/images/i2.png"),
        },
        {
            title: "Streamlined Processes",
            description: "Stelmart’s intuitive interface allows you to move from browsing to buying to delivery without the hassle of complicated steps.",
            icon: require("../../assets/images/i4.png"),
        },
        {
            title: "Enable Smooth Bulk Trading ",
            description: "Optimized procurement and distribution for large-scale transactions with minimal friction.",
            icon: require("../../assets/images/i1.png"),
        },
        {
            title: "Comprehensive Support",
            description: "Stelmart prioritizes customer service and offers dedicated seller support to resolve issues quickly and effectively.",
            icon: require("../../assets/images/i6.png"),
        },
        {
            title: "Real-Time Data & Market Insights",
            description: "Stelmart offers real-time data and updates that allow you to make smarter, more informed business decisions.",
            icon: require("../../assets/images/i5.png"),
        },
    ];


    return (
        <div>
            <div className="choose-carousel-container">
                <div className="choose-heading-container">
                    <h2 className="choose-heading font-merriweather">
                        Why Choose <span>Stelmart?</span>
                        <div className="inline-arrows">
                            <div className="custom-prev-arrow" onClick={() => sliderRef.current.slickPrev()}>
                                <FaArrowLeft />
                            </div>

                            <div className="custom-next-arrow" onClick={() => sliderRef.current.slickNext()}>
                                <FaArrowRight />
                            </div>
                        </div>
                    </h2>
                </div>

                <Slider ref={sliderRef} {...settings}>
                    {data.map((item, index) => (
                        <div key={index} className="choose-card">
                            <div className="choose-icon">
                                <img src={item.icon} alt={item.title} className="choose-icon-img" />
                            </div>
                            <h3 className="choose-title font-merriweather">{item.title}</h3>
                            <p className="choose-description font-poppins">{item.description}</p>
                        </div>
                    ))}
                </Slider>

            </div>
            <div className="choose-yellow-section custom-inner-space custom-container-upper">
                <p className="choose-text font-poppins">
                    Stelmart is the future of trade in the steel and polymer industries. By creating an integrated platform for buyers, sellers, and financial institutions, we are redefining the way products are bought, sold, and financed.                </p>
                <h3 className="choose-bold-text font-merriweather">
                    Join us now and take your business to new heights.
                </h3>
                <button
                    className="read-more-btn font-poppins hover-border-4"
                    onClick={() => navigate("/contact-us")}
                >
                    CONTACT US →
                </button>
            </div>
        </div>
    );
};

export default AboutChoose;
